/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MehrarbeitAuszahlungDto } from '../../models/mehrarbeit-auszahlung-dto';

export interface GetAllMehrarbeitAuszahlungen$Plain$Params {
  date?: string;
  mitarbeiterId?: string;
}

export function getAllMehrarbeitAuszahlungen$Plain(http: HttpClient, rootUrl: string, params?: GetAllMehrarbeitAuszahlungen$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MehrarbeitAuszahlungDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllMehrarbeitAuszahlungen$Plain.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MehrarbeitAuszahlungDto>>;
    })
  );
}

getAllMehrarbeitAuszahlungen$Plain.PATH = '/v1/mehrarbeitauszahlung';
